export default __webpack_public_path__ + "static/media/Avoidance drill.eccb7a92.jpg";